import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/CustomizeField.css';
import '../Customize_Css/ViewVendor.css';
import '../Customize_Css/AddVendor.css';
import '../Customize_Css/Banners.css';
import add from '../Icons/Add.svg';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaPlus, FaSearch, FaSlidersH } from 'react-icons/fa';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
// import '../Customize_Css/Pagination.css';

const CustomizeField = () => {
  const initialData = [
    { id: 1, sectionName: 'Section 1', categories: 'Category 1', fieldName: 'Field 1', fieldType: 'Type 1', fieldDataType: 'Data Type 1', createdBy: 'User 1', modifiedDate: '2024-07-25', isActive: true },
    { id: 2, sectionName: 'Section 2', categories: 'Category 2', fieldName: 'Field 2', fieldType: 'Type 2', fieldDataType: 'Data Type 2', createdBy: 'User 2', modifiedDate: '2024-07-26', isActive: true },
    { id: 3, sectionName: 'Section 3', categories: 'Category 3', fieldName: 'Field 3', fieldType: 'Type 3', fieldDataType: 'Data Type 3', createdBy: 'User 3', modifiedDate: '2024-07-27', isActive: true },
    { id: 4, sectionName: 'Section 4', categories: 'Category 4', fieldName: 'Field 4', fieldType: 'Type 4', fieldDataType: 'Data Type 4', createdBy: 'User 4', modifiedDate: '2024-07-28', isActive: true },
    { id: 5, sectionName: 'Section 5', categories: 'Category 5', fieldName: 'Field 5', fieldType: 'Type 5', fieldDataType: 'Data Type 5', createdBy: 'User 5', modifiedDate: '2024-07-29', isActive: true },
    { id: 6, sectionName: 'Section 6', categories: 'Category 6', fieldName: 'Field 6', fieldType: 'Type 6', fieldDataType: 'Data Type 6', createdBy: 'User 6', modifiedDate: '2024-07-30', isActive: true },
  ];

  const [data, setData] = useState(initialData);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [fieldType, setFieldType] = useState('');
  const [fieldDataType, setFieldDataType] = useState('');
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isVisibleToVendor, setIsVisibleToVendor] = useState(null);

  // Handle button click to update visibility state
  const handleVisibilityChange = (value) => {
    setIsVisibleToVendor(value);
  };

  const handleToggle1 = () => {
    setIsActive(prevState => !prevState);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setData((prevData) => {
      return [...prevData].sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === 'asc' ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    });
  };

  const handleSearch = (value) => {
    setSearchTerm(value.toLowerCase());
    const filteredData = initialData.filter((item) =>
      Object.keys(item).some((key) =>
        item[key].toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setData(filteredData);
    setCurrentPage(1); // Reset to the first page when searching
  };

  const handleSelectAll = () => {
    if (selectedItems.length === data.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data.map(item => item.id));
    }
  };

  const handleSelectItem = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter(item => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleToggle = (id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, isActive: !item.isActive } : item
      )
    );
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleAddField = () => {
    // Add logic to handle adding a new field
    console.log('Field Type:', fieldType);
    console.log('Field Data Type:', fieldDataType);
    handleCloseModal();
    setShowSecondPopup(true); 
  };
 

  const handleCloseSecondPopup = () => {
    setShowSecondPopup(false);
  };
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const columns = [
    ['sectionName', 'Section Name'],
    ['categories', 'Categories'],
    ['fieldName', 'Field Name'],
    ['fieldType', 'Field Type'],
    ['fieldDataType', 'Field Data Type'],
    ['createdBy', 'Created By'],
    ['modifiedDate', 'Modified Date'],
  ];

  return (
    <>
    <Sidebar/>
    <div className="vendors-page">
      <header className="vendors-hero">
        <div>
          <p className="vendors-kicker">Setup</p>
          <h1>Customize Field</h1>
          <p>Choose a module, then add or search custom fields.</p>
        </div>
        <button type="button" className="vendors-primary-btn" onClick={handleShowModal}><FaPlus /> Add Field</button>
      </header>
      <section className="vendors-toolbar">
        <label className="customize-module-label" htmlFor="selectedModule">Selected Models</label>
        <select id="selectedModule" className="form-select customize-module-select">
          <option>Selected Modules</option>
          <option>Module 1</option>
          <option>Module 2</option>
        </select>
        <div className="vendors-search">
          <FaSearch aria-hidden="true" />
          <input type="text" className="form-control" placeholder="Search fields..." value={searchTerm} onChange={(e) => handleSearch(e.target.value)} />
        </div>
      </section>
      <div className="vendors-card">
        <div className="vendors-card-head">
          <div>
            <h2>All Fields</h2>
            <p>Turn a field on or off, or sort a column.</p>
          </div>
          <span className="vendors-count"><FaSlidersH aria-hidden="true" /> {data.length} {data.length === 1 ? 'field' : 'fields'}</span>
        </div>
        <div className="vendors-table-wrap no-scroll">
          <table className="vendors-table vendors-table-plain">
            <thead>
              <tr>
                <th className="vendors-check-cell">
                  <input className="vendors-checkbox" type="checkbox" checked={selectedItems.length === data.length && data.length > 0} onChange={handleSelectAll} />
                </th>
                <th>Status</th>
                {columns.map(([key, label]) => (
                  <th key={key} onClick={() => handleSort(key)}>
                    {label}{sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.map((item) => (
                <tr key={item.id} className={selectedItems.includes(item.id) ? 'is-selected' : ''}>
                  <td className="vendors-check-cell">
                    <input className="vendors-checkbox" type="checkbox" checked={selectedItems.includes(item.id)} onChange={() => handleSelectItem(item.id)} />
                  </td>
                  <td>
                    <div className="form-check form-switch mb-0">
                      <input className="form-check-input" type="checkbox" id={`toggle-${item.id}`} checked={item.isActive} onChange={() => handleToggle(item.id)} style={{ backgroundColor: item.isActive ? '#12956a' : '' }} />
                      <label className="form-check-label" htmlFor={`toggle-${item.id}`}>{item.isActive ? 'on' : 'Off'}</label>
                    </div>
                  </td>
                  <td><span className="vendor-name">{item.sectionName}</span></td>
                  <td>{item.categories}</td>
                  <td>{item.fieldName}</td>
                  <td>{item.fieldType}</td>
                  <td>{item.fieldDataType}</td>
                  <td>{item.createdBy}</td>
                  <td>{item.modifiedDate}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="vendors-card-footer">
          <span className="vendors-page-summary">
            {data.length > 0 ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, data.length)} of ${data.length}` : 'Showing 0 fields'}
          </span>
          <div className="vendors-pagination">
            <ul className="pagination mb-0">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}><button className="page-link btn-sm" onClick={() => setCurrentPage(1)}>&laquo;</button></li>
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}><button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>&lt;</button></li>
              <li className="page-item active"><button className="page-link btn-sm">{currentPage}</button></li>
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}><button className="page-link btn-sm" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>&gt;</button></li>
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}><button className="page-link btn-sm" onClick={() => setCurrentPage(totalPages)}>&raquo;</button></li>
            </ul>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} centered dialogClassName="vendor-details-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add New Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formFieldType">
              <Form.Label>Field Type</Form.Label>
              <Form.Control as="select" value={fieldType} onChange={(e) => setFieldType(e.target.value)}>
                <option>Type 1</option>
                <option>Type 2</option>
                <option>Type 3</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formFieldDataType">
              <Form.Label>Field Data Type</Form.Label>
              <Form.Control as="select" value={fieldDataType} onChange={(e) => setFieldDataType(e.target.value)}>
                <option>Select</option>
                <option>Number</option>
                <option>Textbox</option>
                <option>Multi-Select-Picklist</option>
                <option>Email</option>
              </Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className="vendors-modal-close" onClick={handleCloseModal}>Cancel</Button>
          <Button className="vendor-form-submit" onClick={handleAddField}>Proceed</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showSecondPopup} onHide={handleCloseSecondPopup} size="lg" centered dialogClassName="vendor-details-modal">
      <Modal.Header closeButton>
        <Modal.Title>Select Field Type: Baked Goods</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <label htmlFor="sectionName" className="form-label">Section Name</label>
              <input type="text" className="form-control" id="sectionName" placeholder="Enter section name" />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <label htmlFor="fieldName" className="form-label">Field Name</label>
              <input type="text" className="form-control" id="fieldName" placeholder="Enter field name" />
            </div>
            <div className="col-md-4">
              <label htmlFor="fieldType" className="form-label">Field Type</label>
              <input type="text" className="form-control" id="fieldType" placeholder="Enter field type" />
            </div>
            <div className="col-md-4">
              <label htmlFor="newValue" className="form-label">New Value</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="text" className="form-control" id="newValue" placeholder="Enter new value" />
                <img src={add} alt="Add" style={{ height: 22, width: 22 }} />
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-4">
              <label className="form-label">Mandatory</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="mandatoryToggle"
                  checked={isActive}
                  onChange={handleToggle1}
                  style={{ backgroundColor: isActive ? '#12956a' : '' }}
                />
                <label className="form-check-label" htmlFor="mandatoryToggle">
                  {isActive ? 'Active' : 'Deactivate'}
                </label>
              </div>
            </div>
            <div className="col-md-4">
              <label className="form-label">Visible to Vendor</label>
              <div className="banner-link-toggle" role="group">
                <button type="button" className={isVisibleToVendor === 'yes' ? 'is-active' : ''} onClick={() => handleVisibilityChange('yes')}>Yes</button>
                <button type="button" className={isVisibleToVendor === 'no' ? 'is-active' : ''} onClick={() => handleVisibilityChange('no')}>No</button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="vendor-form-card customize-mini-table" style={{ boxShadow: 'none', marginBottom: 0 }}>
                <div className="vendor-form-card-head">
                  <div className="row w-100">
                    <div className="col text-center">Category</div>
                    <div className="col text-center">SubGoods</div>
                    <div className="col text-center">Re-Order</div>
                  </div>
                </div>
                <div className="vendor-form-card-body">
                  <div className="row">
                    <div className="col text-center">Category</div>
                    <div className="col text-center">Sub</div>
                    <div className="col text-center">Re-Order</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="vendors-modal-close" onClick={handleCloseSecondPopup}>Cancel</Button>
        <Button className="vendor-form-submit" onClick={handleAddField}>Save</Button>
      </Modal.Footer>
    </Modal>
    <div className="vendors-footer"><Footer/></div>
    </div>
    </>
  );
};

export default CustomizeField;
